import widgetConfig from './index';
import style from './../../component/common/style/index.scss';

let centerCls = {
    "justify-content": "center",
    "text-align": "center"
}
let GroupTarget = {

    chartConfig: {
        type: "column2d",
        width: "100%",
        height: "100%",
        dataFormat: "json",

        dataSource: {
            chart: {
                caption: "",
                subCaption: "",
                xAxisName: "Group/course",
                rotateXAxisName: "0",
                rotateYAxisName: "1",
                yAxisName: "Percentage of students",
                theme: "fusion",
                palettecolors: "a1e4df",
                showPlotBorder: "1",
                plotBorderColor: '#00a396',
                plotBorderThickness: "2",
                plotFillHoverColor: "#00a396",
                plotSpacePercent: 48,
                showToolTip: 0,
                showValues: "1",
                YAxisMinValue: '0',
                YAxisMaxValue: '3',
                numDivLines: '2'
            },
            trendlines: [],
            data: []
        }
    },
    legendsClass: [
        style.legendClass1,
        style.legendClass2,
        style.legendClass3
    ],
    tableColumnDefinition: [
        {
            headerName: "Group/course",
            field: "groupName",
            sortable: true,
            minWidth: 200,
            unSortIcon: true,
            sortingOrder: ['asc'],
            cellClass: [style.fontCls].join(' ')
        }
        , {
            headerName: "Percentage of students",
            field: "percentageOfStudents",
            sortable: true,
            minWidth: 200,
            unSortIcon: true,
            sortingOrder: ['asc'],
            cellClass: [style.centerCls, style.fontCls].join(' ')
        }
        , {
            headerName: "Number of students on or above track",
            field: "noOfStudentsAboveTrack",
            width: 220,
            wrapText: true,
            autoHeight: true,
            sortable: true,
            unSortIcon: true,
            sortingOrder: ['asc'],
            cellClass: [style.centerCls,style.fontCls].join(' ')
        }
        , {
            headerName: "Total students",
            field: "totalStudents",
            minWidth: 200,
            wrapText: true,
            autoHeight: true,
            sortable: true,
            unSortIcon: true,
            sortingOrder: ['asc'],
            cellClass: [style.centerCls,style.fontCls].join(' ')
        }

    ],


}

export default GroupTarget;
